<h1 class="sr-only"><span>GANADORES SORTEO ANÁHUAC MAGNO 2026</span></h1>

<section class="bento-g banner-padding">
    <div class="container-fluid">
        <div class="rows sub-headers-inside">

            <div class="col-12 text-center m-auto">
                <div class="overlap-signature header-inside">
                    <h2 class="main-text">Ganadores de</h2>
                    <span class="letter"> <span class="signature-text" style="color: #ff5900 !important;">nuestros
                            sorteos </span></span>

                </div>

                <p>
                    Los afortunados que han dejado huella en nuestros sorteos
                    de aniversario y ediciones especiales. Honramos su entusiasmo, dedicación
                    y confianza en la gran familia Anáhuac.
                </p>
            </div>


        </div>
    </div>
</section>

<section class="sorteo-mosaic">
    <div class="container">
        <div class="row no-gutters">
            <div class="col-md-3 d-flex align-items-end">
                <div class="mosaic-item p-2">
                    <img src="/assets/images/sorteo2026/ganadores_cheque.jpg" class="img-fluid" alt="Ganador Cheque">
                </div>
            </div>

            <div class="col-md-3">
                <div class="mosaic-item p-2 mb-4">
                    <img src="/assets/images/sorteo2026/interior_casa.jpg" class="img-fluid" alt="Interior">
                </div>
                <div class="mosaic-item p-2">
                    <img src="/assets/images/sorteo2026/auto_kia.jpg" class="img-fluid" alt="Auto Nuevo">
                </div>
            </div>

            <div class="col-md-3">
                <div class="mosaic-item p-2 mb-4">
                    <img src="/assets/images/sorteo2026/entrega_llaves.jpg" class="img-fluid" alt="Entrega">
                </div>
                <div class="mosaic-item p-2">
                    <img src="/assets/images/sorteo2026/fachada_casa.jpg" class="img-fluid" alt="Fachada">
                </div>
            </div>

            <div class="col-md-3 d-flex align-items-center">
                <div class="mosaic-item p-2">
                    <img src="/assets/images/sorteo2026/sala_estar.jpg" class="img-fluid" alt="Sala">
                </div>
            </div>
        </div>
    </div>
</section>

<section class="container-gallery mb-5">
    <div class="container">
        <div class="row">
            <div class="col-md-12 text-center">


                <div class="conainter-photos">
                    <div class="row">
                        <div class="col-12">
                            <div class="card-columns-init">



                                <!-- galeria.component.html -->
                                <div class="row" *ngFor="let category of groupedVideos">
                                    <div class="col-12" *ngIf="category.categoria">
                                        <div class="overlap-signature header-inside">
                                            <span class="letter"> <span class="signature-text">
                                                 {{ category.categoria  }} </span></span>


                                        </div>
                                        <h2 class="section-title text-uppercase text-dark mt-5 mb-5 font-weight-bold">

                                        </h2>
                                    </div>


                                    <div class="col-12 mix vg mb-4" *ngFor="let video of category.videos"
                                        data-aos="fade-right"
                                        [attr.data-aos-delay]="category.videos.indexOf(video) * 200">

                                        <div class="card video-card" style="border: 0 !important;">

                                            <div class="card-body"
                                                *ngIf="video.idsVideos && video.idsVideos.length > 0">
                                                <div class="row">
                                                    <div class="col-md-6 mb-4" *ngFor="let idExtra of video.idsVideos">
                                                        <div class="thumbnail">
                                                            <youtube-player [videoId]="idExtra" [height]="300"
                                                                [width]="'100%'"></youtube-player>
                                                        </div>
                                                    </div>
                                                </div>

                                                <!-- <div class="video-details mt-2">
                                                    <div class="video-meta text-left">
                                                        <span class="card-title">{{ video.title }} (Colección de
                                                            videos)</span>
                                                        <div class="channel-info" style="margin-top: 10px;">
                                                            <img src="https://yt3.googleusercontent.com/bHudQN8mAdZ8IE2dhrVzxvOzIHJ0-tyNYGdPcGXaRDkGHFUcADWCUtXJFkmajiwfw4IOX5BjL44=s160-c-k-c0x00ffffff-no-rj"
                                                                [alt]="video.name" class="channel-avatar p-0" />
                                                            <span class="channel-name">{{ video.name }}</span>
                                                        </div>
                                                    </div>
                                                </div> -->
                                            </div>

                                            <div *ngIf="!video.idsVideos || video.idsVideos.length === 0">
                                                <div class="thumbnail">
                                                    <youtube-player [videoId]="video.idVideo" [height]="500"
                                                        [width]="'100%'"></youtube-player>
                                                </div>
                                                <!-- <div class="card-body">
                                                    <div class="video-details">
                                                        <div class="video-meta text-left">
                                                            <span class="card-title">{{ video.title }}</span>
                                                            <div class="channel-info" style="margin-top: 10px;">
                                                                <img src="https://yt3.googleusercontent.com/bHudQN8mAdZ8IE2dhrVzxvOzIHJ0-tyNYGdPcGXaRDkGHFUcADWCUtXJFkmajiwfw4IOX5BjL44=s160-c-k-c0x00ffffff-no-rj"
                                                                    [alt]="video.name" class="channel-avatar p-0" />
                                                                <span class="channel-name">{{ video.name }}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div> -->
                                            </div>

                                        </div>

                                        <div class="row custom-mosaic" *ngIf="video.img?.length > 0">
                                            <div class="col-item" *ngFor="let image of video.img; let i = index">
                                                <img [src]="image.src" alt="Imagen"
                                                    class="img-fluid rounded shadow-sm" />
                                            </div>
                                        </div>
                                        <hr class="line">
                                    </div>
                                </div>







                            </div>
                        </div>
                    </div>

                    <div class="gap"></div>
                    <div class="gap"></div>
                    <div class="gap"></div>
                    <div class="gap"></div>
                </div>
            </div>
        </div>
    </div>
</section>